/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DomainStatusDto } from '../models/DomainStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteDomainStatusControllerService {

    /**
     * Check status of a remote domain
     * @param name
     * @returns DomainStatusDto OK
     * @throws ApiError
     */
    public static getRemoteDomainHealthStatus(
        name: string,
    ): CancelablePromise<DomainStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-domains/{name}/status',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
